import { Organization } from 'lib/types/company';
import { IThemeProperties } from 'lib/types/themes';

const DEFAULT_ETHENA_THEME_PROPERTIES: IThemeProperties = {
  logoUrl: '/images/ethena-learning-center-logo.svg',
  primaryColorHex: '#CA4A2B',
  primaryDarkColorHex: '#BB2D0F',
  primaryLightColorHex: '#FAEFEC',
  primaryAccentColorHex: '#D0684B',
  secondaryColorHex: '#444D56',
  lightColorHex: '#FBFCFD',
  notificationLogoUrl: '/images/ethena-learning-center-logo.svg',
  notificationTrainingButtonFillHex: undefined,
  notificationTrainingButtonTextHex: undefined,
};

const DEFAULT_LIFE_LABS_THEME_PROPERTIES: IThemeProperties = {
  logoUrl: '/images/lifelabs-logo.png',
  primaryColorHex: '#D91D57',
  primaryDarkColorHex: '#CC1B52',
  primaryLightColorHex: '#F7F7F7',
  primaryAccentColorHex: '#FF2266',
  secondaryColorHex: '#414042',
  lightColorHex: '#F6F5F6',
  notificationLogoUrl: '/images/lifelabs-logo.png',
  notificationTrainingButtonFillHex: undefined,
  notificationTrainingButtonTextHex: undefined,
};

export const DEFAULT_THEME_PROPERTIES_BY_ORGANIZATION: Record<
  string,
  IThemeProperties
> = {
  [Organization.ETHENA]: DEFAULT_ETHENA_THEME_PROPERTIES,
  [Organization.LIFE_LABS]: DEFAULT_LIFE_LABS_THEME_PROPERTIES,
};
